import React, { createContext, useEffect, useReducer, useState } from 'react';
import { getBanksCode, getProjects } from '../services/services';

// Crear el contexto
const GlobalContext = createContext();

export default GlobalContext;

const initialState = {
    config: null,
    //urlBase: 'https://app-donations-dev-westeurope.azurewebsites.net/api/'
    //urlBase: 'https://app-donations-pre-westeurope.azurewebsites.net/api/'
    urlBase: 'https://app-donations-pro-westeurope.azurewebsites.net/api'
};

function reducer(state, action) {
    switch (action.type) {
        case 'SET_CONFIG':
            return { ...state, config: action.payload };
        default:
            return state;
    }
}

export const GlobalProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const [urlBase, setUrl] = useState('https://app-donations-pro-westeurope.azurewebsites.net/api/');
    //const [urlBase, setUrl] = useState('https://app-donations-dev-westeurope.azurewebsites.net/api/');



    useEffect(() => {
        // Lee la URL del atributo de datos del elemento
  /*       const rootElement = document.getElementById('ecz-form-baviera-responsable');
        const urlFromData = rootElement.getAttribute('data-url');
        if (urlFromData != null)
            setUrl(urlFromData); */

        let fetching = true;
        const promises = [
            getProjects({urlBase}),
            getBanksCode({urlBase})
        ]

        Promise.all(promises).then(values => {
            const config = {
                projects: values[0],
                codesBanks : values[1]
            }
            if(fetching) dispatch({ type: 'SET_CONFIG', payload: config });
            
        })
        return () => {
            fetching = false;
        }
    }, [])


    
    // El valor que el Provider va a exponer
    const value = {
        config: state.config,
        urlBase
    };

    return (
        <GlobalContext.Provider value={value}>
            {children}
        </GlobalContext.Provider>
    );
};